/**
 * Created by koqiui on 2017-04-12.
 */
import api from './index';

let exports = {};

// =========================== 商品信息 =====================================
//
exports.getGoodsList = function (postData, callback) {// 获取商品分页列表
    api.post('/goods/list/get')
    .data(postData)
    .done(callback)
    .go();
};

//商品详情
exports.getGoods = function (postData, callback) {// 查询商品信息
    api.post('/goods/get')
    .data(postData)
    .done(callback)
    .go();
};
//
exports.getGoodsInfo = function (data, callback) {// 查询商品信息
    api.post('/goods/info/get')
    .data(data)
    .done(callback)
    .go();
};
//
exports.saveGoods = function (data, callback) {// 保存商品的基本信息
    api.post('/goods/save/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.updateGoods = function (data, callback) {// 修改商品信息
    api.post('/goods/update/do')
    .data(data)
    .done(callback)
    .go();
};
// =============================== 商品属性 ==================================
exports.getGoodsAttrValListByGoodsId = function (data, callback) {// 根据goodId获取商品属性值列表
    api.post('/goods/attr/val/list/get/by/goodsId')
    .data(data)
    .done(callback)
    .go();
};
// =============================== 商品图片===================================
//
exports.getGoodsAlbumImgList = function (data, callback) {// 获取商品相册图片列表
    api.post('/goods/albumImg/list/get')
    .data(data)
    .done(callback)
    .go();
};
//
exports.saveGoodsAlbumImg = function (data, callback) {// 保存商品相册图片
    api.post('/goods/albumImg/save/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.deleteGoodsAlbumImg = function (data, callback) {// 删除商品相册图片
    api.post('/goods/albumImg/delete/do')
    .data(data)
    .done(callback)
    .go();
};
// ======================================== 商品介绍 =============================================
exports.getGoodsIntroByGoodsId = function (data, callback) {// 根据goodsId获取商品介绍信息
    api.post('/goods/intro/get/by/goodsId')
    .data(data)
    .done(callback)
    .go();
};
// ======================================== 商品介绍图片 ==========================================
//
exports.getGoodsIntroImgList = function (data, callback) {// 获取商品介绍相册列表
    api.post('/goods/introImg/list/get')
    .data(data)
    .done(callback)
    .go();
};
exports.saveGoodsIntroImg = function (data, callback) {// 保存商品介绍图片
    api.post('/goods/introImg/save/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.deleteGoodsIntroImg = function (data, callback) {// 删除商品介绍图片
    api.post('/goods/introImg/delete/do')
    .data(data)
    .done(callback)
    .go();
};
// ================================= 商品规格使用情况 ==================================================
//
exports.getGoodsSpecUsageList = function (data, callback) {// 获取使用规格列表
    api.post('/goods/spec/usage/list/get')
    .data(data)
    .done(callback)
    .go();
};
// ========================= sku =================================================
//
exports.getSkuList = function (data, callback) {// 获取SKU列表
    api.post('/goods/sku/list/get')
    .data(data)
    .done(callback)
    .go();
};
//
exports.getPagedSkuList = function (postData, callback) {// 获取SKU分页列表
    api.post('/goods/sku/paged/list/get')
    .data(postData)
    .done(callback)
    .go();
};
//
exports.getSkuAccRelList = function (postData, callback) {// 获取某商品已关联的配件信息列表
    api.post('/goods/sku/acc/rel/list/get')
    .data(postData)
    .done(callback)
    .go();
};

// Mku
exports.getMkuPagedList = function (postData, callback) {// 获取MKU分页列表
    api.post('/goods/mku/paged/list/get')
    .data(postData)
    .done(callback)
    .go();
};
//==========商品展示信息============

//商品审核申请
exports.applyGoodsCertApplyForm = function (postData, callback) {// 商品证书申请
    api.post('/goods/cert/applyForm/apply/do')
    .data(postData)
    .done(callback)
    .go();
};

//获取商品证书列表
exports.getGoodsCertApplyFormList = function (postData, callback) {// 获取商品证书申请分页列表
    api.post('/goods/cert/applyForm/list/get')
    .data(postData)
    .done(callback)
    .go();
};

//商品申请详情
exports.getGoodsCertApplyFormInfo = function (postData, callback) {// 查询商品证书详情
    api.post('/goods/cert/applyForm/info/get')
    .data(postData)
    .done(callback)
    .go();
};

// 审核记录列表
exports.getGoodsCertAuditRecList = function (postData, callback) {// 获取商品证书审核记录列表
    api.post('/goods/cert/audit/rec/list/get')
    .data(postData)
    .done(callback)
    .go();
};

//MKU列表
exports.getMkuList = function (postData, callback) {// 获取MKU列表
    api.post('/goods/mku/list/get')
    .data(postData)
    .done(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/goods.js
// module id = 41
// module chunks = 1